// extracted by mini-css-extract-plugin
export var numberInputContainer = "_9b-0";
export var startPickingButton = "_9b-1";